module.exports = __webpack_public_path__ + "static/truck-f62ba235e808e15bfebf7a848c484334.svg";